import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHECKIN_REVIEW_STORE_NAME, CheckinReviewState } from './checkin-review.state';

/** Select CheckinReview State */
export const selectCheckinReviewState = createFeatureSelector<CheckinReviewState>(CHECKIN_REVIEW_STORE_NAME);

/** 全ての搭乗者のDetailsボタンの開閉状態を取得する */
export const selectDetailsOpenStatus = createSelector(selectCheckinReviewState, (state) => state.model);

/** 指定された搭乗者のDetailsボタンの開閉状態を取得する */
export const selectDetailsOpenStatusByTraveler = (travelerId: string) =>
  createSelector(selectCheckinReviewState, (state) => state.model[travelerId]);
